import { InjectionToken } from '@angular/core';
import { TLanguage } from '@core/config/lanugages';

export const IS_SERVER: InjectionToken<boolean> = new InjectionToken('isServer');
export const SELECTED_LANGUAGE: InjectionToken<TLanguage> = new InjectionToken('selectedLanguage');
